// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2VkLG","buttons":"RemoveExpirationActionButtons_buttons__vKyfO"};